// src/utils/api.js - Cliente API centralizado
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({ baseURL: API_URL });

// Adjuntar token automáticamente
api.interceptors.request.use(config => {
  const token = localStorage.getItem('wawita_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Manejar errores globalmente
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('wawita_token');
      localStorage.removeItem('wawita_user');
      window.location.href = '/admin/login';
    }
    return Promise.reject(err);
  }
);

export default api;
